import React, { useMemo } from 'react';

const icons = import.meta.glob('/src/assets/images/**/*.{svg,png,jpg,jpeg,webp}', {
	eager: true,
	// as: 'url',
	query: '?url',
	import: 'default',
});

function getImage(folder, fileName, format) {
	const path = `/src/assets/images/${folder}/${fileName}.${format}`;
	return icons[path];
}

export default function LynIcon({ folder, fileName, format = 'svg', sx }) {
	const iconSrc = useMemo(() => {
		return getImage(folder, fileName, format);
	}, [folder, fileName, format]);

	if (!iconSrc) return null;

	return <img src={iconSrc} alt={fileName} style={{ ...sx }} />;
}
